import React, { useEffect, useState } from "react";
import {
  Box,
  FormControlLabel,
  Checkbox,
  Typography,
  alpha,
  useTheme,
} from "@mui/material";

const CustomCheckbox = ({
  name,
  label,
  isInitiallyChecked = false,
  onClick,
  onChange,
  checked: propChecked,
  disabled = false,
  size = "medium",
  ...props
}) => {
  const theme = useTheme();
  const [isChecked, setChecked] = useState(isInitiallyChecked || propChecked || false);

  useEffect(() => {
    if (propChecked !== undefined) {
      setChecked(propChecked);
    }
  }, [propChecked]);

  useEffect(() => {
    if (isInitiallyChecked !== undefined && propChecked === undefined) {
      setChecked(isInitiallyChecked);
    }
  }, [isInitiallyChecked, propChecked]);

  const handleCheckboxClick = (event) => {
    const updatedChecked = event.target.checked;
    setChecked(updatedChecked);

    if (onClick) {
      onClick(updatedChecked, name);
    }
    if (onChange) {
      onChange(event);
    }
  };

  const getSizeStyles = () => {
    if (size === "small") {
      return {
        fontSize: 16,
        padding: "4px",
      };
    }
    if (size === "large") {
      return {
        fontSize: 24,
        padding: "8px",
      };
    }
    return {
      fontSize: 20,
      padding: "6px",
    };
  };

  const sizeStyles = getSizeStyles();

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        position: "relative",
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.6 : 1,
        transition: "all 0.2s ease",
        "&:hover": {
          "& .MuiCheckbox-root": {
            backgroundColor: !disabled ? alpha(theme.palette.primary.main, 0.04) : "transparent",
          },
        },
      }}
    >
      <FormControlLabel
        control={
          <Checkbox
            name={name}
            checked={isChecked}
            onChange={handleCheckboxClick}
            disabled={disabled}
            sx={{
              color: "#D0D5DD",
              padding: sizeStyles.padding,
              "&.Mui-checked": {
                color: theme.palette.primary.main,
                "&:hover": {
                  backgroundColor: alpha(theme.palette.primary.main, 0.04),
                },
              },
              "& .MuiSvgIcon-root": {
                fontSize: sizeStyles.fontSize,
              },
              "&:hover": {
                backgroundColor: !disabled ? alpha(theme.palette.primary.main, 0.04) : "transparent",
              },
              borderRadius: "4px",
            }}
            {...props}
          />
        }
        label={
          <Typography
            component="span"
            variant="body2"
            sx={{
              fontWeight: 500,
              color: isChecked ? theme.palette.primary.main : "#475467",
              fontSize: size === "small" ? "0.75rem" : size === "large" ? "0.95rem" : "0.85rem",
              ml: 0.5,
              transition: "color 0.2s ease",
              userSelect: "none",
            }}
          >
            {label}
          </Typography>
        }
        sx={{
          margin: 0,
          "& .MuiFormControlLabel-label": {
            marginLeft: 0.5,
          },
        }}
      />
    </Box>
  );
};

export default CustomCheckbox;